import { Alarm } from './Alarm';

export interface Worker {
  address: string;
  alternativeFqdn: string;
  bootTime: Date;
  cloudBursting: boolean;
  configurationId: number;
  cpuCapabilities: string;
  cpuCount: number;
  cpuModel: string;
  deployStatus: string;
  description: string;
  domain: string;
  enableDistributedDatabase: boolean;
  enableSsh: string;
  gateway: string;
  hostname: string;
  hypervisor: string;
  id: number;
  ipv6Address: string;
  ipv6Gateway: string;
  lastAttemptedContact: Date;
  lastReported: Date;
  lastUpdated: Date;
  maintenanceMode: boolean;
  managed: boolean;
  maxAudioCalls: number;
  maxFullHdCalls: number;
  maxHdCalls: number;
  maxMediaTokens: number;
  maxSdCalls: number;
  mediaLoad: number;
  mediaPriorityWeight: number;
  mediaTokensUsed: number;
  name: string;
  netmask: string;
  nodeType: string;
  resourceUri: string;
  secondaryAddress: string;
  secondaryNetmask: string;
  serviceManager: boolean;
  servicePolicy: boolean;
  signalingCount: number;
  signalling: boolean;
  snmpAuthenticationPassword: string;
  snmpCommunity: string;
  snmpMode: string;
  snmpPrivacyPassword: string;
  snmpSystemContact: string;
  snmpSystemLocation: string;
  snmpUsername: string;
  staticNatAddress: string;
  staticRoutes: string[];
  syncStatus: string;
  systemLocation: string;
  totalRam: number;
  transcoding: boolean;
  upgradeStatus: string;
  version: string;
  alarms: Alarm[];
}

export const bytesToSize = (bytes: any) => {
  bytes *= 1000;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return 'n/a';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1000)).toString(), 10);
  if (i === 0) return `${bytes} ${sizes[i]})`;
  return `${(bytes / (1000 ** i)).toFixed(1)} ${sizes[i]}`;
};
